import type { IntercomSettings } from '../interfaces/intercom';

import { INTERCOM_API_BASE, INTERCOM_APP_ID } from '.';

export const SHARED_INTERCOM_SETTINGS: IntercomSettings = {
  api_base: INTERCOM_API_BASE,
  app_id: INTERCOM_APP_ID,
  hide_default_launcher: false,
};
